// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  ClientType,
} from "./types";


export default __t.row({
  connectionId: __t.connectionId().primaryKey().name("connection_id"),
  userIdentity: __t.identity().name("user_identity"),
  get clientType() {
    return ClientType.name("client_type");
  },
  connectedAt: __t.timestamp().name("connected_at"),
});
